export const resolveCommunityRecordId = (row = {}) => {
  if (!row || typeof row !== 'object') return '';

  const direct =
    row.record_Id ?? row.record_ID ?? row.Record_Id ?? row.Record_ID ?? row.recordId ?? row.RecordId ?? row.record_id ?? row.id ?? row.Id ?? row.ID ?? '';

  if (direct !== null && direct !== undefined && String(direct).trim() !== '') {
    return String(direct).trim();
  }

  const matchedKey = Object.keys(row).find((key) => {
    const normalized = key.replace(/_/g, '').toLowerCase();
    return normalized === 'recordid';
  });

  if (matchedKey && row[matchedKey] !== null && row[matchedKey] !== undefined && String(row[matchedKey]).trim() !== '') {
    return String(row[matchedKey]).trim();
  }

  return '';
};

const isCommunityApiSuccess = (data) => {
  if (!data) return false;
  if (data.isSuccessful === true) return true;
  const statusCode = Number(data.statusCode);
  return [200, 201, 202].includes(statusCode);
};

const isSuccessApiMessage = (message = '') => /fetched successfully|retrieved successfully|successfully/i.test(String(message).trim());

const unwrapCommunityResult = (data) => {
  const result = data?.result;
  if (!result) return null;

  if (result?.data && typeof result.data === 'object' && !Array.isArray(result.data)) {
    return result.data;
  }

  if (Array.isArray(result)) {
    const first = result[0];
    if (!first) return null;
    if (first?.data && typeof first.data === 'object') return first.data;
    return first;
  }

  if (typeof result === 'object') {
    const nested = result.community ?? result.Community;
    if (nested && typeof nested === 'object') return nested;
    return result;
  }

  return null;
};

export const pickCommunityField = (row, ...keys) => {
  for (const key of keys) {
    const val = row?.[key];
    if (val !== null && val !== undefined && String(val).trim() !== '' && val !== '0') {
      return String(val).trim();
    }
  }
  return '';
};

export const resolveCommunityNo = (row = {}) => pickCommunityField(row, 'communityNo', 'CommunityNo');

export const toSelectOption = (items, label) => {
  if (!label) return null;
  const normalized = String(label).trim();
  const hit = (items || []).find((item) => {
    const text = String(item?.text ?? '').trim();
    const itemLabel = String(item?.label ?? '').trim();
    const value = String(item?.value?.value ?? item?.value ?? '').trim();
    return text === normalized || itemLabel === normalized || value === normalized;
  });
  if (hit) {
    return { label: hit.text ?? hit.label ?? normalized, value: hit };
  }
  return { label: normalized, value: { text: normalized, value: normalized } };
};

export const fetchCommunityCountries = async (apiService) => {
  const params = new URLSearchParams();
  params.append('dropdownTypes', 'CommunityCountry');
  const res = await apiService.getApiParamater('COMMUNITY_MULTIDROP', `?${params.toString()}`);
  return res?.data?.dropdowns?.CommunityCountry || [];
};

export const fetchCommunityCitiesByCountry = async (apiService, countryName) => {
  if (!countryName) return [];
  const params = new URLSearchParams();
  params.append('DropdownFor', 'CommunityCityDescByCountry');
  params.append('CascadText', countryName);
  const res = await apiService.getApiParamater('COMMUNITY_CASCAD', `?${params.toString()}`);
  return res?.data?.items || [];
};

export const fetchCommunityByRecordId = async (apiService, recordId) => {
  const id = String(recordId).trim().replace(/^\//, '');
  if (!id) {
    throw new Error('Record id is required');
  }
  const res = await apiService.getApiParamater('GET_COMMUNITY_BY_ID', `/${encodeURIComponent(id)}`);
  const data = res?.data;
  const community = unwrapCommunityResult(data);

  if (community) {
    return community;
  }

  if (isCommunityApiSuccess(data)) {
    throw new Error('Community not found');
  }

  const message = String(data?.message || '').trim();
  if (isSuccessApiMessage(message)) {
    throw new Error('Community not found');
  }

  throw new Error(message || 'Failed to load community');
};

export const buildCommunityNavigationState = (row, viewOnly = false) => {
  const recordId = resolveCommunityRecordId(row);
  return {
    ...row,
    record_Id: recordId,
    recordId,
    viewOnly,
  };
};
